import { render, staticRenderFns } from "./AddEditLoans.vue?vue&type=template&id=6fec2f12&scoped=true"
import script from "./AddEditLoans.vue?vue&type=script&lang=js"
export * from "./AddEditLoans.vue?vue&type=script&lang=js"
import style0 from "./AddEditLoans.vue?vue&type=style&index=0&id=6fec2f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fec2f12",
  null
  
)

export default component.exports